import { jsx as _jsx } from "react/jsx-runtime";
export function ZoomIcon({ size = 24, className }) { return _jsx("svg", { width: size, height: size, className: className }); }
//# sourceMappingURL=ZoomIcon.js.map